import { NgHybridStateDeclaration } from '@uirouter/angular-hybrid';

import { MailchimpSettingsComponent } from './mailchimp.settings.component';
import { SessionService }             from '../sessions/session.service';

export const MailchimpStates : Array<NgHybridStateDeclaration> = [
  {
    component: MailchimpSettingsComponent,
    name     : 'app.mailchimp-settings',
    resolve  : [
      {
        deps     : [ SessionService ],
        resolveFn: ( sessionService : SessionService ) : Promise<any> => sessionService.refresh(),
        token    : 'session'
      }
    ],
    url: '/mailchimp-settings'
  }
];
